export default __webpack_public_path__ + "static/media/myaccountavatar.aeb7e402.png";